import React, {useEffect} from "react";
import {Redirect, Route, Switch, useLocation,} from "react-router-dom";
import {SettingsPage} from "../features/settings";
import {TakeoffsRouter} from "../features/project-list";
import {initWalkMe, removeWalkMe} from "../utils/WalkMeUtils";
import {useUpdatedRef} from "../hooks/useUpdatedRef";
import {pages, paths, useNavigator} from "../features/navigator";
import {useMeDataContext} from "../providers/MeProvider";

const MainRouter: React.FC = () => {

	const {navigateTo} = useNavigator()
	const {user} = useMeDataContext()
	const locationSearch = useLocation().search
	const dataRef = useUpdatedRef({locationSearch, navigateTo})

	useEffect(() => {
		initWalkMe();
		return removeWalkMe;
	}, [])

	useEffect(function pendoIdentify() {
		if (!user || !window.pendo) return

		// Same IDs as the old encodedUri/e launch params: scheme-less Simpro URL + employee ID
		const accountId = user.simproUrl.replace(/^[a-z][a-z0-9+.-]*:\/\//i, "")
		window.pendo.initialize({
			visitor: {
				id: `${accountId}-${user.simproUserId}`,
			},
			account: {
				id: accountId,
			}
		});
	}, [user])

	useEffect(function urlParamRedirect() {
		const {locationSearch, navigateTo} = dataRef.current
		const query = new URLSearchParams(locationSearch)

		if (query.has("q")) {
			navigateTo(pages.simproIdQuotePage(query.get("q")!))
		}
		if (query.has("j")) {
			navigateTo(pages.simproIdJobPage(query.get("j")!))
		}
	}, [dataRef]);

	return (
		<Switch>
			<Route path={paths.settings} component={SettingsPage}/>
			<Route path={paths.takeoffs} component={TakeoffsRouter}/>
			<Redirect to={paths.takeoffs}/>
		</Switch>
	);
};

export {MainRouter}
